import React, { useCallback, useEffect, useMemo } from "react";
import ReactDOM from "react-dom";
import { Modal, Button, message, Tooltip } from "antd";
import { openModalTextBox } from "../ModalTextBox";
import Icon from "../../Icon";
import { _Active, selectArrayType } from "./types";
import { ActionFnEnum, ICurrentRouteInfo, MenusType } from "../../types";
import api from "../../api";
import { useTranslation } from "../../context";
import AppRuntimeEnv from "@/types/AppRuntimeEnv";
import "./index.less";
import { FolderTypeNames, folderTypeEnum } from "@/components/Joyspace/config/permissions.config";
import SelectTree from "./SelectTree";
import events from "../../context/events";
import { useLocation } from "react-router-dom";
import { getSpaceIdByRootId, handleRootId, isMySpace } from "../../util";
import { folderType } from "../../config/permissions.config";
import { analysisLog } from "@/utils/logAnalytics";
import { getPageMenuLogId } from "../../contextMenus/utils";
interface Props {
  title: string;
  currentRouteInfo?: ICurrentRouteInfo;
  isTeam?: boolean;
  // type?: 'myspace' | 'teamspace' | 'other';
  callback?: (
    data: {
      id?: string;
      type?: folderTypeEnum | null;
      rootId?: string;
      name?: string;
      tabKey?: string;
    },
    close: () => void
  ) => void;
  treeFreshFunction?: Function;
  visible?: boolean;
  selectArray?: selectArrayType[];
  canSelectMy?: boolean;
  onClose?: () => void; // 供本文件使用，外部调用不需要传
  appRuntimeEnv?: AppRuntimeEnv;
  defaultNav?: any;
  reload?: Function;
  isCopy?: boolean; // 复制到
  isMoveSave?: boolean; // 转存到
  from?: string;
  originId?: string;
  ExtraNode?: any;
  isGroupSpace?: boolean; // 组空间
}
enum TabType {
  JOYSPACE = "joyspace",
  GROUPSPACE = "groupspace"
}
export default function Picker(props: Props) {
  const lang = useTranslation();
  const {
    selectArray,
    isTeam,
    callback,
    onClose,
    canSelectMy = false,
    currentRouteInfo,
    appRuntimeEnv,
    treeFreshFunction,
    defaultNav,
    reload,
    isCopy,
    title,
    from,
    originId = "",
    isMoveSave,
    isGroupSpace
  } = props;
  const [selectType, setSelectType] = React.useState<"file" | "folder" | "both">("both");
  const [excludesFolerMap, setExcludesFolerMap] = React.useState<any>({});
  const [visible, setVisible] = React.useState(props.visible ?? true);
  const [addabled, setAddabled] = React.useState(true);
  const [doConfirmable, setConfirmable] = React.useState(true);
  const [tabKey, setTabKey] = React.useState<TabType>(TabType.GROUPSPACE);
  const [active, setActive] = React.useState<_Active>({
    id: folderType.MY,
    type: folderTypeEnum.MY,
    name: FolderTypeNames.MY
  });
  useEffect(() => {
    // 有选中时传入，移动和复制功能
    let selectType = "folder";
    // 选中的如果有文件夹则需要过滤掉。
    const selectFolerMap: {
      [key: string]: any;
    } = {};
    if (selectArray) {
      let fileCount = 0;
      let folderCount = 0;
      selectArray?.forEach((item) => {
        if (item.type === "folder") {
          folderCount++;
          selectFolerMap[item.id] = 1;
        } else if (item.type === "file") {
          fileCount++;
        }
      });
      if (fileCount > 0 && folderCount === 0) {
        selectType = "file";
      } else if (fileCount > 0 && folderCount > 0) {
        selectType = "both";
      } else {
        selectType = "folder";
      }
      setSelectType(selectType as any);
      setExcludesFolerMap(selectFolerMap);
      // 如果不都是文件夹 共享文件的根不可选择
      // if (selectType !== 'folder') {
      //     navlinks[1].selectable = false;
      //     navlinks[1].disabled = true;
      // }
    }
  }, [selectArray]);
  useEffect(() => {
    // 如果不都是文件夹 共享文件的根不可选择置灰确定按钮
    if (selectType !== "folder" && active.id === folderType.SHARE) {
      setConfirmable(false);
    } else {
      setConfirmable(true);
    }
  }, [active, selectType]);
  useEffect(() => {
    if (defaultNewNav) {
      return;
    }
    if (isTeam) {
      setActive({
        id: folderType.SHARE,
        type: folderTypeEnum.SHARE,
        name: FolderTypeNames.SHARE
      });
    } else {
      setActive({
        id: folderType.MY,
        type: folderTypeEnum.MY,
        name: FolderTypeNames.MY
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isTeam, setActive]);
  const ok = React.useCallback(
    (active: _Active) => {
      // const type = active.type;
      const data = {
        ...active,
        tabKey
      };
      console.log(data, "data=====>");
      callback?.(data, () => {
        setVisible(false);
      });
    },
    [tabKey, callback]
  );

  function createCategory(active: _Active, setActive: (a: _Active) => void) {
    return () => {
      openModalTextBox({
        title: lang("c.categoriesPicker.create"),
        onOk: (value, close) => {
          api.categories.create(active?.id ?? "", value).then((resData) => {
            if (resData?.data) {
              const data = resData.data;
              // tree数据更新
              data.isShared = active.isShared || false;
              data.title = data.name;
              data.isFolder = true;
              events.emit("freshLeftTreeByFolderById", active?.id || "");
              events.emit("selectTreeAddNode", data, active?.id);
              events.emit("list.check");
              // 文档左侧导航更新
              message.success(lang("common.success"));
              reload?.();
              close();
              // console.log(originId, "移动到复制到组件新建文件夹===>", active?.id);
              const toId = handleRootId(active?.id);
              const res = getSpaceIdByRootId(originId, active?.id);
              console.log(originId, "移动到复制到组件新建文件夹===>", active?.id, toId, data);
              if (res) {
                events.emit("list.partial.refresh", {
                  changeData: { newItem: data, type: ActionFnEnum.ADD },
                  folderId: toId,
                  key: MenusType.SPACE
                });
              }
            } else {
              message.error(resData?.status || lang("common.fail"));
            }
          });
        }
      });
    };
  }

  const handleCancle = useCallback(() => {
    setVisible(false);
    setTimeout(() => onClose?.(), 1000);
  }, [onClose]);
  const defaultNewNav = useMemo(() => {
    if (isMoveSave && tabKey === TabType.JOYSPACE) {
      setActive({
        id: folderType.MY,
        type: folderTypeEnum.MY,
        name: FolderTypeNames.MY
      });
      return null;
    }
    if ((isMoveSave && tabKey === TabType.GROUPSPACE) || isGroupSpace) {
      setActive({
        id: defaultNav?.[0]?.id,
        type: folderTypeEnum.GROUP,
        name: defaultNav?.[0]?.name
      });
    }
    return defaultNav;
  }, [defaultNav, isMoveSave, tabKey, isGroupSpace]);
  const UseSelectTree = React.useMemo(() => {
    return (
      <SelectTree
        defaultNav={defaultNewNav}
        canSelectMy={canSelectMy}
        type={isMoveSave ? "myspace" : !isTeam ? "myspace" : "teamspace"}
        setActive={setActive}
        setAddabled={setAddabled}
        setConfirmable={setConfirmable}
        // currentRouteInfo={currentRouteInfo}
        // selectArray={selectArray}
        selectType={selectType}
        excludesFolerMap={excludesFolerMap}
        isMoveSave={isMoveSave}
        isGroupSpace={isGroupSpace}
        // categoriesInterceptor={props.categoriesInterceptor}
      />
    );
  }, [isTeam, selectType, excludesFolerMap, canSelectMy, defaultNewNav, isMoveSave, isGroupSpace]);

  const getTitle = useCallback(() => {
    // console.log(isCopy,'isCopyisCopyisCopyisCopyisCopyisCopy')

    if (isMoveSave) {
      return (
        <div>
          {lang("ctx.addTo.title.prefix")}「
          <Tooltip title={title}>
            <span className="operate-title-ellipsis">{title}</span>
          </Tooltip>
          」{lang("ctx.addTo.title.suffix")}
        </div>
      );
    }
    return (
      <div>
        {isCopy ? lang("ctx.copy.title.prefix") : lang("ctx.move.dialog.prefix")}「
        <Tooltip title={title}>
          <span className="operate-title-ellipsis">{title}</span>
        </Tooltip>
        」{isCopy ? lang("ctx.copy.title.suffix") : lang("ctx.move.dialog.suffix")}
      </div>
    );
  }, [isCopy, title, isMoveSave, lang]);

  const onCancel = useCallback(
    (byButton: boolean) => {
      handleCancle();
      const logId = getPageMenuLogId(
        isCopy ? (byButton ? "copyCancel" : "copyClose") : byButton ? "moveCancel" : "moveClose"
      );
      analysisLog("xtbg_jzb_joyspace_home_1676548210761", logId, from || "");
    },
    [handleCancle, isCopy, from]
  );
  const extraNode = useMemo(() => {
    return isMoveSave && isTeam ? (
      <div data-header>
        <Button
          type={tabKey === TabType.JOYSPACE ? "primary" : "default"}
          onClick={() => {
            setTabKey(TabType.JOYSPACE);
          }}
          className="spacepicker-tree-extraNode-button"
        >
          文档协同
        </Button>
        <Button
          type={tabKey === TabType.GROUPSPACE ? "primary" : "default"}
          onClick={() => {
            setTabKey(TabType.GROUPSPACE);
          }}
          className="spacepicker-tree-extraNode-button"
        >
          当前群空间
        </Button>
      </div>
    ) : null;
  }, [isMoveSave, tabKey, isTeam]);
  return (
    <Modal
      visible={visible}
      footer={null}
      title={getTitle()}
      width={480}
      className="joyspace-spacepicker-tree"
      onCancel={() => {
        onCancel(false);
      }}
      destroyOnClose
      style={{ top: "calc((100% - 500px) / 2)" }}
    >
      <div data-main>
        {extraNode}
        {UseSelectTree}
        <div data-footer>
          {addabled && (
            <span data-create onClick={createCategory(active, setActive)}>
              {/* <Icon type="iconlog_add" className="joyspace-spacepicker-add-icon" /> */}
              <span>{lang("c.categoriesPicker.create")}</span>
            </span>
          )}
          <Button
            type="default"
            onClick={() => {
              onCancel(true);
            }}
          >
            {lang("common.cancel")}
          </Button>
          <Button type="primary" disabled={!doConfirmable} onClick={() => ok(active)}>
            {isMoveSave ? lang("ctx.addTo.confirm") : lang("common.confirm")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export function openPicker(props: Props) {
  const ele = document.createElement("div");
  document.body.appendChild(ele);
  function onClose() {
    if (ele) {
      ReactDOM.unmountComponentAtNode(ele);
      ele.remove();
    }
  }
  ReactDOM.render(<Picker {...{ ...props, onClose }} />, ele);
}
